import React from 'react';
import styled from 'styled-components';

import { FaAngleUp } from 'react-icons/fa'
import { ToggleButton } from 'features'

const Container = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;
    min-height: 2.5rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    border-bottom: 1px solid var(--primary-accent-color);
    padding: 0 0.3rem;
    width: 100%;
`

const Title = styled.div`
    align-items: center;
    font-weight: bolder;
    font-size: 0.9rem;
    padding-left: 0.5rem;
    word-wrap: break-word;
    color: ${props => props.active ? 'var(--text-color)' : 'var(--secondary-accent-color)'};
    @media not all and (min-resolution:.001dpcm) { 
        -webkit-text-decoration-line: ${props => !props.active ? 'line-through' : null};
    };
    
    @media screen and (-webkit-min-device-pixel-ratio:0) and (min-resolution:.001dpcm) {
        text-decoration: ${props => !props.active ? 'line-through' : null};
        text-decoration-color: var(--secondary-accent-color);
        // text-decoration-thickness: 1rem; // Will cause issues for Firefox
    };
`


const SectionBlock = props => {
    const {
        title
    } = props;

    return (
        <Container>
            <ToggleButton open={true} alignment='center' styles={{backgroundColor: 'transparent', padding: '0.3rem', fontSize: '1rem'}} icon={<FaAngleUp/>} end={180}/>                 
            <Title active={true}>{title}</Title>
        </Container>
    )
}

export default SectionBlock;